import styled from "styled-components";

export const Stroke = styled.div`
  position: relative;
  height: 4px;
  background-color: ${(props) => (props?.isPassed ? "#00BCF1" : "#dde2e8")};
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  width: auto;
  user-select: none;
  overflow-x: auto;
  margin-top: 8px;
  touch-action: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  column-gap: 4px;
  margin: 4px 0;

  h1 {
    font-size: 12px;
    margin: 0;
    padding: 0;
    line-height: 18px;
  }
`;

export const Title = styled.div`
  font-family: Gilroy;
  font-size: 12px;
  margin: 0;
  padding: 0;
  line-height: 12px;
  font-weight: ${(props) =>
    props?.isActive || props?.isPassed ? "bold" : "normal"};
  color: ${(props) =>
    props?.isActive ? "#00BCF1" : props?.isPassed ? "#0c8ce9" : "#6A7481"};
`;

export const Subtitle = styled.div`
  font-family: Gilroy;
  font-size: 12px;
  margin: 0;
  padding: 0;
  line-height: 12px;
  font-weight: ${(props) => (props?.isActive ? "bold" : "normal")};
  color: ${(props) => (props?.isActive ? "#f48120" : "#6A7481")};
`;

export const BoxWrapper = styled.div`
  position: relative;
  left: 60px;
`;

export const Box = styled.div`
  display: flex;
  justify-content: ${(props) => (props?.lastBox ? "flex-start" : "flex-end")};
  align-items: center;
  width: 135px;
  margin: 4px 0;

  .circle-path {
    width: 14px;
    height: 14px;
  }

  .check-path {
    width: 14px;
    height: 14px;
  }

  .circle-path rect {
    stroke: ${(props) => (!props?.isActive ? "#dde2e8" : "#00BCF1")};
  }

  .circle-path circle {
    fill: ${(props) => (!props?.isActive ? "#dde2e8" : "#00BCF1")};
  }

  .check-path circle {
    fill: ${(props) => (props?.isPassed ? "#0c8ce9" : "#dde2e8")};
  }
`;
